import { CSSProperties, useState } from 'react';
import { useIntl } from 'react-intl';
import { InputField, InputFieldProps } from '@ets/design-system';

import { Timepicker } from '_common/components';

import type { TimepickerProps } from '_common/components/Timepicker/Timepicker';

export type TimepickerFieldProps = Required<Pick<InputFieldProps, 'label'>> &
  Pick<InputFieldProps, 'disabled'> &
  Pick<TimepickerProps, 'value' | 'onChange'> &
  Pick<CSSProperties, 'margin'> & {
    testId: {
      inputField: InputFieldProps['testId'];
      timepicker: TimepickerProps['testId'];
    };
  };

const TimepickerField = ({
  label,
  disabled,
  margin,
  value,
  testId,
  onChange,
}: TimepickerFieldProps) => {
  const intl = useIntl();
  const [hasError, setHasError] = useState(false);

  const handleChange: TimepickerFieldProps['onChange'] = (isValid, newValue, actionMeta) => {
    setHasError(!isValid);

    if (onChange) {
      onChange(isValid, newValue, actionMeta);
    }
  };

  return (
    <InputField
      label={label}
      disabled={disabled}
      feedbackContent={hasError ? intl.formatMessage({ id: 'ENTER_A_VALID_TIME_FORMAT' }) : null}
      size="m"
      style={{ margin }}
      testId={testId.inputField}
    >
      <Timepicker
        size="m"
        disabled={disabled}
        value={value}
        onChange={handleChange}
        testId={testId.timepicker}
      />
    </InputField>
  );
};

export default TimepickerField;
